import React, { useState } from 'react';
import { FormControl, Select, makeStyles, Typography } from '@material-ui/core';
// import { FormControl, InputLabel, Select } from '@mui/material';

export interface BaseSearchDropdownFieldProps {
  id: string;
  label: string;
  onChange: React.ChangeEventHandler<
    | HTMLInputElement
    | HTMLTextAreaElement
    | HTMLSelectElement
    | { name?: string; value: unknown }
  >;
  filters: any;
  filterKey: string;
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    margin: theme.spacing(1),
    marginRight: theme.spacing(1),
    paddingRight: theme.spacing(2),
    marginTop: '4px',
    '& .MuiOutlinedInput-root': {
      borderRadius: 8,
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderRadius: 8,
    },
  },
  label: {
    // removed left padding to align label with other search fields
  },
}));

const SearchDropdownField: React.FC<BaseSearchDropdownFieldProps> = (props) => {
  const classes = useStyles();
  const { id, label, onChange, filters, filterKey } = props;
  const [labelWidth] = useState(0);

  return (
    <FormControl margin={'dense'} variant="outlined" className={classes.root}>
      <Typography variant="body2" className={classes.label}>
        {label}
      </Typography>
      <Select
        id={id}
        name={filterKey}
        displayEmpty
        value={filters[filterKey]}
        onChange={onChange}
      >
        {props.children}
      </Select>
    </FormControl>
  );
};

export default SearchDropdownField;
